const { __ } = wp.i18n;
const colors = [
	{
		name: __('Black', 'boilerplate'),
		color: '#000000',
	},
	{
		name: __('White', 'boilerplate'),
		color: '#ffffff',
	},
	{
		name: __('Red', 'boilerplate'),
		color: '#ff0000',
	},
	{
		name: __('Green', 'boilerplate'),
		color: '#00ff00',
	},
	{
		name: __('Blue', 'boilerplate'),
		color: '#0000ff',
	},
	{
		name: __('Yellow', 'boilerplate'),
		color: '#ffff00',
	},
];
export default colors;
